import { css, Global, Theme } from '@emotion/react';
import emotionNormalize from 'emotion-normalize';

type Size = {
    mobileS: string;
    mobileM: string;
    mobileL: string;
    tablet: string;
    laptop: string;
    laptopL: string;
    desktop: string;
    desktopL: string;
};

const size: Size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '400px',
    tablet: '630px',
    laptop: '1030px',
    laptopL: '1280px',
    desktop: '1580px',
    desktopL: '1820px',
};

export const theme: Theme = {
    colors: {
        green1: '#E7F6D9',
        green2: '#AECF8D',
        green3: '#59862C',
        green5: '#38442C',
        gray1: '#FCFCFC',
        gray2: '#D2DEE2',
        gray4: '#7B878F',
        gray5: '#353633',
        yellow3: ' #D9A413',
    },
    device: {
        mobileS: `(min-width: ${size.mobileS})`,
        mobileM: `(min-width: ${size.mobileM})`,
        mobileL: `(min-width: ${size.mobileL})`,
        tablet: `(min-width: ${size.tablet})`,
        laptop: `(min-width: ${size.laptop}) and (orientation:landscape)`,
        laptopL: `(min-width: ${size.laptopL}) and (orientation:landscape)`,
        desktop: `(min-width: ${size.desktop}) and (orientation:landscape)`,
        desktopL: `(min-width: ${size.desktopL}) and (orientation:landscape)`,
    },
};

export const GlobalStyles = () => {
    return (
        <Global
            styles={() => css`
                ${emotionNormalize};
                html,
                body {
                    scroll-behavior: smooth;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                }
                body {
                    font-weight: normal;
                    font-size: 1rem;
                    word-wrap: break-word;
                    font-kerning: normal;
                    overflow-x: hidden;

                    word-wrap: break-word;
                    margin: 0;
                    font-family: 'Poppins';
                    -webkit-font-smoothing: antialiased;
                }
                a {
                    text-decoration: none;
                }
                p {
                    margin-bottom: 16px;
                    a,
                    span {
                        color: ${theme.colors.green3};
                        font-weight: bold;
                    }
                }
                .container,
                .small-container,
                .large-container {
                    padding: 0px 16px;
                }
                ul {
                    padding: 0;
                }
                h1,
                h2,
                h3,
                h4,
                h5,
                h6,
                p,
                ul,
                li,
                button,
                div {
                    color: ${theme.colors.gray5};
                    margin: 0;
                }
                .link {
                    font-weight: 700;
                    text-decoration: none;
                    color: ${theme.colors.green3};
                }

                button {
                    border: none;
                    outline: none;
                    background: none;
                }
                .header {
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 152.5%;
                    color: ${theme.colors.gray5};
                }
                .header-2 {
                    text-transform: uppercase;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 28px;
                    line-height: 132.5%;
                    letter-spacing: 0.12em;
                    color: ${theme.colors.gray5};
                }
                p {
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 152.5%;
                    color: ${theme.colors.gray5};
                }
                @media ${theme.device.mobileL} {
                    .container,
                    .small-container,
                    .large-container {
                        padding: 0px 16px;
                    }
                }
                @media ${theme.device.tablet} {
                    .container,
                    .small-container,
                    .large-container {
                        max-width: 720px;
                        margin: 0 auto;
                    }
                }
                @media ${theme.device.laptop} {
                    .small-container {
                        padding: 0px;
                        max-width: 930px;
                    }
                    .container {
                        padding: 0;
                        max-width: 980px;
                    }
                    .large-container {
                        padding: 0;
                        max-width: 1020px;
                    }
                    .header {
                        font-weight: 700;
                        font-size: 48px;
                        line-height: 152.5%;
                    }
                    .header-2 {
                        font-weight: 700;
                        font-size: 40px;
                        line-height: 132.5%;
                        text-align: center;
                        text-transform: uppercase;
                    }
                }
                @media ${theme.device.laptopL} {
                    .container {
                        max-width: 1064px;
                        margin: 0 auto;
                    }
                    .large-container {
                        max-width: 1200px;
                    }
                }
                @media ${theme.device.desktopL} {
                    .container {
                        margin: 0 auto;
                    }
                }
                #widget-floatingEstimator-mount button span {
                    color: white !important;
                }
            `}
        />
    );
};
